import { InputWithLabel } from '@adotel/components'
import { Button, Hidden, Typography } from '@material-ui/core'
import RightIcon from '@material-ui/icons/ArrowRightAlt'
import React, { useEffect, useState } from 'react'

import { getTranslate } from '../../localization'
import {
  RatePlanDeatials,
  RatePlanForPMSMappingList,
  RoomTypeForPMSMappingList
} from '../../types/accommodationPMSMapping'
import useStyles from './styles/RoomTypeItemBox.styles'

interface RoomTypeItemBoxProps {
  roomTypeIndex: number
  loading: boolean
  data: RoomTypeForPMSMappingList
  EditModal: any
  onChangePMSCodeInput: (AdotelCode: string, newPMSCode: string) => void
  onRatePlansChange: (
    AdotelCode: string,
    rateplans: RatePlanForPMSMappingList[],
    updatedRateplans: RatePlanDeatials[]
  ) => void
  disableRatePlan?: boolean
  disabled: boolean
  loadingForMappedCodeBox?: boolean
  haveSuppurtRatePlans: boolean
  customizedForChannel?: boolean
}

const RoomTypeItemBox: React.FC<RoomTypeItemBoxProps> = ({
  roomTypeIndex,
  loading,
  data,
  EditModal,
  onChangePMSCodeInput,
  onRatePlansChange,
  disableRatePlan,
  disabled,
  haveSuppurtRatePlans,
  customizedForChannel
}) => {
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [rateplans, setRateplans] = useState<RatePlanForPMSMappingList[]>(
    data.RatePlans
  )
  const [changedData, setChangedData] = useState<RatePlanDeatials[]>([])
  // write this state(inputValue) to track change of mapped code values
  const [inputValue, setInputValue] = useState<RoomTypeForPMSMappingList>(data)

  useEffect(() => {
    setRateplans(data.RatePlans)
    setInputValue(data)
  }, [data, haveSuppurtRatePlans])

  const onClick = () => {
    setIsOpen(true)
  }

  return (
    <div>
      <div
        className={[classes.itemBox, disabled ? classes.disabled : ''].join(
          ' '
        )}>
        <Typography
          variant="h4"
          className={classes.title}
          data-cy={
            roomTypeIndex === 0 ? 'AccommodationPMSMappingItemboxTitle' : null
          }>
          {inputValue.AdotelName}
        </Typography>
        <div className={classes.codeMappingContianer}>
          <div>
            <InputWithLabel
              data-cy={
                roomTypeIndex === 0
                  ? 'AccommodationPMSMappingFirstRoomTypeBoxAdotelCode'
                  : null
              }
              defaultValue={inputValue.AdotelCode}
              noHelperText
              label={getTranslate('Adotel Code')}
              viewMode
              value={inputValue.AdotelCode}
              inputSize="small"
            />
          </div>
          <div
            className={[
              classes.button,
              !haveSuppurtRatePlans &&
              inputValue.RatePlans.every((r) => r.PMSCode === '')
                ? ''
                : haveSuppurtRatePlans &&
                  !customizedForChannel &&
                  data.RatePlans?.some(
                    (rp) =>
                      rp.PMSCode === '' ||
                      rp.PMSCode?.toLocaleLowerCase() === 'nodata'
                  )
                ? classes.errorBox
                : ''
            ].join(' ')}>
            {!disableRatePlan && (
              <Button
                data-cy={
                  roomTypeIndex === 0
                    ? 'AccommodationPMSMappingFirstRoomTypeBoxRatePlansButton'
                    : null
                }
                variant="contained"
                onClick={onClick}
                size="small"
                className={classes.btn}
                disabled={disabled}
                fullWidth>
                <Typography>{getTranslate('RatePlans')}</Typography>
              </Button>
            )}
          </div>
          <Hidden smDown>{loading ? <span /> : <RightIcon />}</Hidden>
          <div className={classes.mappedCodeContainer}>
            <InputWithLabel
              data-cy={
                roomTypeIndex === 0
                  ? 'AccommodationPMSMappingFirstRoomTypeBoxPMSCode'
                  : null
              }
              value={inputValue.PMSCode}
              noHelperText
              label={getTranslate('Mapped Code')}
              inputSize="small"
              onChange={(event) => {
                onChangePMSCodeInput(
                  inputValue.AdotelCode,
                  event.currentTarget.value
                )
                setInputValue({
                  ...inputValue,
                  PMSCode: event.currentTarget.value
                })
              }}
              error={!inputValue.PMSCode}
              autoComplete="new-password"
              disabled={disabled}
            />
          </div>
        </div>
      </div>
      {isOpen && (
        <EditModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          data={rateplans}
          setData={setRateplans}
          allRatePlans={inputValue.RatePlans}
          onRatePlansChange={onRatePlansChange}
          adotelCodeForRoomtype={inputValue.AdotelCode}
          changedData={changedData}
          setChangedData={setChangedData}
          customizedForChannel={customizedForChannel}
        />
      )}
    </div>
  )
}

export default RoomTypeItemBox
